/**
 * This component is responsible for displaying a game event eg goal or penalty
 */
import React from 'react';
import ImageContainer from '../core/ImageContainer';
import ProfileImageContainer from "../core/ProfileImageContainer.js";

const GameEvent = ({ eventName, time, clubImg, player, club, profile, eventText, title }) => {

    return (
        <div className="py-2 x-4 flex flex-row items-center justify-between lg:w-full w-full max-lg:px-4 border-b-2 border-light-3 dark:border-dark-2">
            {title ? (
                // Content when title is true
                <div className="flex xs:h-12 justify-center items-center w-full">
                    <p className="text-xl py-1 xs:py-2 leading-tight">{eventName}</p>
                </div>
            ) : (
                // Content when title is false
                <div className="flex flex-col xl:flex-row items-center justify-start w-full">
                    <div className="flex-row flex max-xl:items-center max-xl:mb-1">
                        <p className="text-sm w-16 max-xl:text-center my-auto">{time}</p>
                        <div className="w-8 h-8 xl:w-10 xl:h-10 ml-4 xl:ml-8">
                            <ImageContainer src={`${clubImg}`} alt={club} extraClasses={"rounded-full"} />
                        </div>
                        <div className="w-8 h-8 xl:w-10 xl:h-10 ml-1">
                            <ProfileImageContainer player={player} club={club} backup={profile} alt={player} extraClasses={"rounded-full"}/>
                        </div>
                    </div>
                    <>
                        <div className=" w-full flex flex-col justify-center items-start xl:ml-8">
                            <p className="max-xs:text-xs text-xsm max-xl:leading-tight max-xl:text-center w-full">{eventName}</p>
                            <p className="text-xxs max-xl:leading-tight font-light text-darken mt-0.5 max-xl:text-center w-full">{eventText}</p>
                        </div>
                    </>

                </div>
            )}
        </div>
    );
};

export default GameEvent;